import { URLS, resolvePublicServiceUrl } from "@itaas/ports";
import {
  PEP_CANONICAL_PRODUCTION_ORIGIN,
  resolvePepRuntimeSiteUrl,
} from "@itaas/pep-contracts";

export const SUITE_URL = resolvePublicServiceUrl(
  import.meta.env.VITE_SUITE_URL,
  "VITE_SUITE_URL",
  URLS.SUITE_WEB,
);

export const PEP_API_BASE = "/api/pep";

/** Public absolute origin for SEO (canonical / OG). Never defaults to itas.com. */
export const SITE_URL = resolvePepRuntimeSiteUrl(
  import.meta.env.VITE_PEP_SITE_URL ?? PEP_CANONICAL_PRODUCTION_ORIGIN,
);

/** URL publique PEP pour les liens de parrainage (origine courante en prod). */
export function getPepSiteUrl(): string {
  if (
    typeof window !== "undefined" &&
    window.location?.origin &&
    !window.location.origin.startsWith("file:")
  ) {
    return window.location.origin.replace(/\/$/, "");
  }
  return SITE_URL;
}

/** Ligne directe équipe technique / suivi livraison matériel biométrique. */
export const TECH_SUPPORT_PHONE =
  import.meta.env.VITE_TECH_SUPPORT_PHONE ?? "+243 830 676 007";

/** Email support commercial / technique affiché sur le PEP. */
export const SUPPORT_CONTACT_EMAIL =
  import.meta.env.VITE_SUPPORT_CONTACT_EMAIL ?? "contact@itaas-rdc.com";
